exports.globalParamsSchema = {
  token: ''
}
exports.acquisitionInfoSchema = {
  rewardedAmount: 0,
  pendingAmount: 0
}
